import { useEffect, useState } from 'react';
import { Form, Input, Button, message, Select } from "antd";
import { useLocation, useNavigate } from 'react-router-dom';
import { Country, CountryService } from "../../services/Country";
import { getCurrentUser, USER_ROLES, UserService } from '../../services/User';

function UserAdd() {

    const navigate = useNavigate();
    const { state } = useLocation();
    const [countries, setCountries] = useState<Country[]>([]);
    const [form] = Form.useForm();
    const currentUser = getCurrentUser();
   
    useEffect( () => {
        const getCountries = async () => {
            const {data} = await CountryService.getAll()
            setCountries(data)
        }
        getCountries();
        
    }, [])


    const save = async (values: any) => {
        let country = currentUser.role === USER_ROLES.ADMIN ? values.country : currentUser.country
        const { data } = await UserService.create({ ...values, active: true, country});
        message.success('New User added!')
        navigate(`/admin/users`, { replace: true })
    };

    return (
        <div className='wrapper'>
            <h1>Add User</h1>
            <Form
                name="basic"
                form={form}
                onFinish={save}
                scrollToFirstError={true}
                className='add-item'
                layout="vertical"
                style={{padding:0}}
            >
                 <Form.Item name="name" label="Name" >
                    <Input />
                </Form.Item>

                <Form.Item name="email" label="Email" >
                    <Input />
                </Form.Item>

                {currentUser.role === USER_ROLES.ADMIN && <Form.Item name="country" label="Country">
                    <Select>
                        {countries.map( country => 
                            (<Select.Option value={country._id} key={country._id}>
                                {country.name}
                            </Select.Option>)
                        )}
                    </Select>
                </Form.Item>}

                {currentUser.role === USER_ROLES.ADMIN && <Form.Item name="role" label="Role">
                    <Select>
                        <Select.Option value={USER_ROLES.ADMIN_COUNTRY} key={USER_ROLES.ADMIN_COUNTRY}>
                                Country Admin
                        </Select.Option>
                        <Select.Option value={USER_ROLES.USER} key={USER_ROLES.USER}>
                                User
                        </Select.Option>
                    </Select>
                </Form.Item>}
                
                <Form.Item>
                    <Button type="primary" htmlType="submit" className="form-submit-button">
                        SAVE
                    </Button>
                </Form.Item>
            </Form>
            
        </div>

    );
}

export default UserAdd;